<template>
	<transition name="modal">
		<div class="modal-mask delete-modal-box">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div>
						<div class="modal-header">
							<slot name="header">default header</slot>
						</div>

						<div class="modal-body">
							<button class="modal-default-button cta-btn save-btn" @click="$emit('back')">Go Back</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
    export default {
        name: "SaveDeniedModal"
    };
</script>

<style scoped>
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 300px;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-container .cta-btn {
		padding: 5px 14px;
		background: #ffffff;
		font-size: 11px;
		margin-right: 5px;
	}

	.modal-container .cta-btn:hover,
	.modal-container .cta-btn.active {
		background-color: #003656;
		color: #fff;
	}

	.delete-modal-box .modal-container {
		width: 450px;
		min-height: 170px;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
		align-items: center;
		-moz-align-items: center;
		-webkit-align-items: center;
	}

	.delete-modal-box .modal-container .modal-default-button {
		float: left;
	}

	.delete-modal-box .modal-container .modal-body:after {
		content: "";
		display: table;
		clear: both;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
		text-align: center;
	}

	.delete-modal-box .modal-header {
		width: 100%;
		margin-bottom: 20px;
	}

	.delete-modal-box .modal-header h3 {
		color: #8f8f8f;
	}
	.delete-modal-box .modal-body {
		margin: 10px 0;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		align-items: center;
		-moz-align-items: center;
		-webkit-align-items: center;
	}

	.modal-default-button {
		float: right;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}
</style>
